import $ from 'jquery';
import { TweenMax, TimelineMax, Back, Power2 } from 'gsap';
require('../libs/CustomEase');

function MenuDesktop(rootSelector) {
  this.attr = 'data-main-submenu-target';
  this.closeDelay = 100;
  this.elems = {};
  this.elems.root = $(rootSelector);
  this.elems.logo = this.elems.root.find('.main-logo');
  this.elems.topmenu = this.elems.root.find('.top-menu');
  this.elems.menus = this.elems.root.find('.main-menu-li');
  this.elems.dropdowns = this.elems.root.find('[' + this.attr + ']');

  this.startAnimation();
  this.bindHover();
}

MenuDesktop.prototype.bindHover = function() {
  let self = this;

  let lastTarget = null;
  
  this.elems.dropdowns.each(function() {
    let thisMenu = $(this);
    let thisTarget = $(thisMenu.attr(self.attr));

    let _timeout = null;
    let _isOpen = false;

    let openMenu = () => {
      console.log('openMenu');
      clearTimeout(_timeout);
      if(!_isOpen) {
        thisMenu.addClass('hover');
        thisTarget.fadeIn();
        if(lastTarget && lastTarget !== thisTarget) lastTarget.fadeOut(100);
        lastTarget = thisTarget;
        _isOpen = true;
      }
    };

    let closeMenu = () => {
      console.log('closeMenu');
      _timeout = setTimeout(() => {
        thisMenu.removeClass('hover');
        thisTarget.fadeOut();
        _isOpen = false;
      }, self.closeDelay);
    };

    thisMenu.hover(openMenu, closeMenu);
    thisTarget.hover(openMenu, closeMenu);
  });
};

MenuDesktop.prototype.startAnimation = function() {
  let self = this;

  // @ START RESET
  TweenMax.set(this.elems.menus, {
    position: 'relative',
    top: '-35px',
    opacity: 0,
  });
  TweenMax.set(this.elems.topmenu, {
    position: 'relative',
    top: '25px',
    opacity: 0,
  });
  TweenMax.set(this.elems.logo, {
    scale: 0,
    opacity: 0,
  });
  this.elems.root.removeClass('will-animate');
  // @ END RESET

  // @ START LOGO
  TweenMax.to(this.elems.logo, .6, {
    scale: 1,
    opacity: 1,
    delay: .3,
    ease: Back.easeOut.config(2),
  });
  // @ END LOGO

  // @ START TOPMENU
  TweenMax.to(this.elems.topmenu, .9, {
    opacity: 1,
    top: 0,
    delay: (this.elems.menus.length + 1) * .15,
    ease: Power2.easeOut,
  });
  // @ END TOPMENU
  
  // @ START MENUS
  this.elems.menus.each(function(index) {
    let thisMenu = $(this);
    let delay = index * .15;
    TweenMax.to(thisMenu, .9, {
      top: 0,
      delay,
      // ease: CustomEase.create("custom", "M0,0 C0.032,0.063 0.018,0.702 0.084,0.868 0.14,1.01 0.202,1.108 0.288,1.142 0.378,1.177 0.54,1 0.624,1 0.711,1 0.929,1 1,1"),
      ease: Back.easeOut.config(2.7),
    });
    TweenMax.to(thisMenu, .6, {
      opacity: 1,
      delay: delay,
      ease: Power2.easeOut,
    });
  });
  // @ END MENUS
};

export default MenuDesktop;
